import styled from "styled-components";

export const CheckboxButtonStyled = styled.input``;
